// Splide init
function mmInitSplide() {
    const id = ".mm-dc-slider";
    const splideElem = document.querySelector(id);

    if (splideElem) {
        new Splide(splideElem, {
            type: "loop",
            pagination: false,
            arrows: false,
            drag:true,
            wheel:true,
            waitForTransition :true,
            wheelSleep :200,
            gap: 12,
            fixedWidth: "240px",
            padding: {
                left: 20,
            },
        }).mount();
    }

    const idRea = ".splide-mm-cart-rea";
    const splideElemRea = document.querySelector(idRea);

    if (splideElemRea) {
        new Splide(splideElemRea, {
            type: "loop",
            pagination: true,
            autoplay: true,
            arrows: false,
            gap: 12,
            perPage: 1,
            padding: {
                left: 20,
            },
        }).mount();
    }
}

document.addEventListener(
    "DOMContentLoaded",
    () => {
        mmInitSplide();
    },
    { once: true }
);

// Debounce
// https://redd.one/blog/debounce-vs-throttle
// If function is called several times in {duration},
// wait for a pause longer than {duration} to actually trigger it.
// eg, wait 500 milliseconds after last call to actually call doSomething():
// debounce(function () {
//    doSomething();
//  }, 500)
function debounce(func, duration) {
    let timeout;
    return function (...args) {
        const effect = () => {
            timeout = null;
            return func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(effect, duration);
    };
}

function mmCartSectionElement() {
    return document.getElementById("shopify-section-mm-cart");
}

function mmCartProductsContainerElement() {
    return mmCartSectionElement().querySelector(".mm-dc-products-container");
}

function mmCartItem(productVariantId) {
    return mmCartProductsContainerElement().querySelector(`[data-cart-item-id="${productVariantId}"]`);
}

function mmCartItemQuantityEl(productVariantId) {
    const itemEl = mmCartItem(productVariantId);

    return itemEl.querySelector("[data-item-quantity]");
}

function mmGetCartItemQuantity(productVariantId) {
    const quantityEl = mmCartItemQuantityEl(productVariantId);

    return Number.parseInt(quantityEl.dataset.itemQuantity);
}

function mmSetCartItemQuantity(productVariantId, newQuantity) {
    if (newQuantity >= 0) {
        const quantityEl = mmCartItemQuantityEl(productVariantId);

        quantityEl.dataset.itemQuantity = newQuantity;
        quantityEl.innerText = newQuantity;
    }
}

function mmCartHTMLFromData(data) {
    const el = document.createElement("DIV");
    el.innerHTML = data.sections["mm-cart"];

    return el;
}

function extractItemsFromCartHTML(data) {
    const el = mmCartHTMLFromData(data);
    return el.querySelector(".mm-dc-products-container");
}

function insertCartProductsFromResponse(data) {
    const itemsContainer = extractItemsFromCartHTML(data);
    mmCartProductsContainerElement().innerHTML = itemsContainer.innerHTML;

    return data;
}

function extractTotalPriceFromCartHTML(data) {
    const cartEl = mmCartHTMLFromData(data); // ¡ fait atención gringo !
    return cartEl.querySelector("[data-cart-total-price]");
}

function insertInsertTotalPriceFromResponse(data) {
    const newTotalPriceEl = extractTotalPriceFromCartHTML(data);
    const currentTotalPriceEl = mmCartSectionElement().querySelector("[data-cart-total-price]");
    currentTotalPriceEl.innerHTML = newTotalPriceEl.innerHTML;

    return data;
}

function mmAPIRequest(method, path, body) {
    document.querySelector(".mm-dc-products").classList.add("mm-inactive");
    return fetch(window.Shopify.routes.root + path, {
        method: method,
        headers: { "Content-Type": "application/json" },
        body: body ? JSON.stringify(body) : undefined,
    })
        .then((response) => response.json())
        .then((data) => {
            document.querySelector(".mm-dc-products").classList.remove("mm-inactive");
            if (mmCartSectionElement().querySelector(".mm-dc-free-item-progress--inner")) {
                const freeItemsProgress = mmCartSectionElement().querySelector(".mm-dc-free-item-progress--inner");
                const newWidth = (data.total_price / document.getElementById("mmCartProgressBarValue").value) * 100;
                freeItemsProgress.style.width = `${newWidth}%`;

                if (data.total_price >= document.getElementById("mmCartProgressBarValue").value) {
                    document.querySelector(".mm-dc-free-item-progress-text_succes").style.display = "block";
                    document.querySelector(".mm-dc-free-item-progress-text_not_yet").style.display = "none";
                } else {
                    document.querySelector(".mm-dc-free-item-progress-text_succes").style.display = "none";
                    document.querySelector(".mm-dc-free-item-progress-text_not_yet").style.display = "block";
                }
                const montantRestant = document.querySelector(".mm-dc-free-item-progress-text span");
                if (montantRestant) {
                    montantRestant.innerText = ((document.getElementById("mmCartProgressBarValue").value - data.total_price) / 100).toFixed(2);
                }
            }
            updateCartCount(data.item_count != null ? data.item_count : 0);
            return data;
        })
        .then((data) => {
            if (data.status && data.status > 400) {
                throw data;
            } else {
                return data;
            }
        });
}

// récupérer le panier
function mmGetCart() {
    mmAPIRequest("GET", "cart.js").then(console.log);
}

// Ouvrir le panier
function mmOpenCart() {
    document.querySelector(".mm-drawer-cart-filter").classList.add("mm-dc-is-open");
    document.querySelector("html").classList.add("stop-scrolling");
}

// Fermer le panier
function mmCloseCart() {
    document.querySelector(".mm-drawer-cart-filter").classList.remove("mm-dc-is-open");
    document.querySelector("html").classList.remove("stop-scrolling");
}

// Re-render cart inner HTML from response
function refreshCartFromData(data) {
    const newCartEl = document.createElement("DIV");
    newCartEl.innerHTML = data.sections["mm-cart"];
    const innerCart = mmCartSectionElement().querySelector(".mm-drawer-cart-filter");
    innerCart.innerHTML = newCartEl.querySelector(".mm-drawer-cart-filter").innerHTML;
    updateCartCount(newCartEl.querySelector("[data-cart-count]").dataset.cartCount);
    mmInitSplide();
    mmAddOrRemoveActivationProduct(data);
}

/*
// Ajouter un item au panier
function mmAddProductToCart(productId, { quantity = 1, openCart = true }) {
    mmDisableCheckout(true)
    mmAPIRequest("POST", "cart/add.js", {
        items: [{ quantity: quantity, id: productId }],
        sections: "mm-cart",
    })
        .then(refreshCartFromData)
        .then((data) => {
            if (openCart) {
                setTimeout(mmOpenCart);
            }
        })
        .then(mmDisableCheckout(false))
        .catch((error) => {
            mmCartProductsContainerElement().innerHTML = `
        Oups, il y a eu une erreur, essayez de recharger la page !
        `;
            mmOpenCart();
            console.log(error);
        });
}*/
function mmAddProductToCart(productId, { quantity = 1, openCart = true }) {
    mmDisableCheckout(true);

    // only add if product is not already in the cart
    mmAPIRequest("GET", "cart.js", null)
        .then(cart => {
            const isProductInCart = cart.items.some(item => item.id === productId);

            if (!isProductInCart) {
                return mmAPIRequest("POST", "cart/add.js", {
                    items: [{ quantity: quantity, id: productId }],
                    sections: "mm-cart",
                })
                    .then(refreshCartFromData)
                    .then((data) => {
                        Promise.resolve()
                    })
                    .then(mmDisableCheckout(false))
                    .catch((error) => {
                        mmCartProductsContainerElement().innerHTML = `
                    Oups, il y a eu une erreur, essayez de recharger la page !
                    `;
                        setTimeout(mmOpenCart);
                    });
            }

            return Promise.resolve()
        })
        .then(data => {
            if (openCart) {
                setTimeout(mmOpenCart);
            }
        })
        .catch(error => {
             mmCartProductsContainerElement().innerHTML = `
        Oups, il y a eu une erreur, essayez de recharger la page !
        `;
            setTimeout(mmOpenCart);
            console.log(error);
        })
        .finally(() => {
            mmDisableCheckout(false);
        });
}

function mmIncreaseProductQuantity(productVariantId) {
    const quantity = mmGetCartItemQuantity(productVariantId);
    const newQuantity = quantity + 1;
    mmSetCartItemQuantity(productVariantId, newQuantity);

    mmDebouncedPushNewQuantity(productVariantId);
}

function mmDecreaseProductQuantity(productVariantId) {
    const quantity = mmGetCartItemQuantity(productVariantId);
    const newQuantity = quantity - 1;
    mmSetCartItemQuantity(productVariantId, newQuantity);

    mmDebouncedPushNewQuantity(productVariantId);
}

function mmDecreaseActivationProductQuantity(productVariantId, qtty) {
    const quantity = mmGetCartItemQuantity(productVariantId);
    const newQuantity = quantity - qtty;
    console.log("quantity", quantity);
    console.log("qtty", qtty);
    console.log("new quantity", newQuantity);
    mmSetCartItemQuantity(productVariantId, newQuantity);

    mmDebouncedPushNewQuantity(productVariantId);
}

function mmDestroyProductFromCart(productVariantId) {
    const newQuantity = 0;
    mmSetCartItemQuantity(productVariantId, newQuantity);
    mmDebouncedPushNewQuantity(productVariantId);
}

function mmPushNewQuantity(productVariantId) {
    const quantity = mmGetCartItemQuantity(productVariantId);
    mmDisableCheckout(true);
    mmAPIRequest("POST", "cart/change.js", {
        id: productVariantId.toString(),
        quantity: quantity,
        sections: "mm-cart",
    })
        .then(insertCartProductsFromResponse)
        .then(insertInsertTotalPriceFromResponse)
        .then(mmAddOrRemoveActivationProduct)
}

const mmDebouncedPushNewQuantity = debounce(function (productVariantId) {
    mmPushNewQuantity(productVariantId);
}, 300);

function mmAddOrRemoveActivationProduct(data) {
    if (data.sections["mm-cart"]) {
        // Récupérer les éléments HTML pour les produits spécifiques et les produits déclencheurs
        const triggerIds = [];
        const ProductToAdd = document.querySelector("[data-specific-products]");
        const triggerProducts = Array.from(document.querySelectorAll("[data-trigger-products] [data-trigger-id]"));

        // Créer l'array de productToAddIds
        triggerProducts.forEach(function (triggerProduct) {
            triggerIds.push(triggerProduct.dataset.triggerId);
        });

        // Vérifier si des produits déclencheurs sont présents dans le panier
        const cartItems = Array.from(document.querySelectorAll("[data-cart-item]"));

        var counter = 0;
        cartItems.forEach(function (cartItem) {
            // check if current cart item is a trigger product
            if (triggerIds.includes(cartItem.dataset.cartItemId)) {
                var itemQuantity = cartItem.dataset.itemQuantity;
                console.log("current item is a trigger product");
                counter += parseInt(itemQuantity);
                console.log("nb trigger items in cart :", counter);
            }
        });

        // Compter le nb de frais d'activation au panier
        var counterActivationProducts = 0;
        cartItems.forEach(function (cartItem) {
            if (cartItem.dataset.cartItemId == ProductToAdd.dataset.productId) {
                counterActivationProducts += parseInt(cartItem.dataset.itemQuantity);
            }
        });

        var activationsToAdd = counter - counterActivationProducts;
        console.log("counterActivationProducts", counterActivationProducts);
        console.log("activationsToAdd", activationsToAdd);

        if (activationsToAdd > 0) {
            mmAddProductToCart(ProductToAdd.dataset.productId, { quantity: activationsToAdd });
        } else if (activationsToAdd < 0) {
            var positiveQuantity = activationsToAdd * -1;
            console.log(positiveQuantity);
            console.log(ProductToAdd.dataset.productId);
            mmDecreaseActivationProductQuantity(ProductToAdd.dataset.productId, positiveQuantity);
        }else{
            mmDisableCheckout(false)
        }
    }
    return data;
}

// PROGRESS BAR
function mmProgressBar() {}

function updateCartCount(value) {
    if(value != 0 || value != '0'){
        document.querySelector('.mm-cart-count').classList.remove('mm-none');
    }else{
        document.querySelector('.mm-cart-count').classList.add('mm-none');

    }
    document.querySelector(".mm-cart-count-bubble-value").innerText = value;
}

function mmDisableCheckout(booleen) {
    var btn = document.querySelector(".mm-dc-cta ");
    if (booleen) {
        btn.href = "javascript: void(0)";
        btn.classList.add("disabled");
    } else {
        btn.href = "/checkout";
        btn.classList.remove("disabled");
    }
}
